import { GraphLoginConnectButton } from './login/GraphLoginConnectButton';

export const HeaderLogin = () => {
  // const { graphdebate } = useWebsite();
  // const isSsoActive = graphdebate?.sso?.active || isNmSsoTest;

  return <GraphLoginConnectButton />;
  // return isSsoActive ? <SsoConnectButton sso={graphdebate?.sso!} /> : <GraphLoginConnectButton />;
};
